<template>
  <div class="Partners">
    <div class="Partners_title">合作伙伴</div>
    <div class="Partners_bar">
      <ul>
        <li :class="chooseNum == 1 ? 'active' : ''" @mouseenter="chooseNum = 1">
          企业品牌
        </li>
        <li :class="chooseNum == 2 ? 'active' : ''" @mouseenter="chooseNum = 2">
          战略合作
        </li>
        <li :class="chooseNum == 3 ? 'active' : ''" @mouseenter="chooseNum = 3">
          合作院校
        </li>
      </ul>
    </div>

    <div class="Partners_list">
      <!-- 品牌 -->
      <ul v-show="chooseNum == 1">
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p1.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p2.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p3.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p5.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p6.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p7.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p8.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p9.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p10.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p11.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p12.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p13.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p14.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner01/p15.png"
            alt=""
          />
        </li>
      </ul>
      <!-- 合作 -->
      <ul v-show="chooseNum == 2">
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p01.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p02.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p03.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p04.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p05.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p06.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p07.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p08.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p09.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p10.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p11.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p12.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p13.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p14.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner03/p15.png"
            alt=""
          />
        </li>
      </ul>
      <!-- 学校 -->
      <ul v-show="chooseNum == 3">
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p1.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p2.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p3.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p4.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p5.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p6.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p9.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p10.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p11.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p12.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p13.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p14.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p15.png"
            alt=""
          />
        </li>
        <li>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/partner02/p16.png"
            alt=""
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooseNum: 1,
    };
  },
};
</script>

<style lang="less">
@import url("@/statis/css/base.less");

.Partners {
  width: 100%;
  height: auto;
  background: #fafcff;

  &_title {
    font-size: 36px;
    font-weight: 400;
    color: #000;
    user-select: none;
    line-height: 14vw;
  }

  &_bar {
    width: 70%;
    height: 5vw;
    margin: auto;

    ul {
      width: 90%;
      height: 100%;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      border-bottom: 4px solid rgba(191, 184, 184, 0.107);

      li {
        width: 20%;
        height: 80%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 20px;
        position: relative;
        cursor: pointer;
      }

      .active {
        &::after {
          content: "";
          width: 50%;
          height: 5px;
          background: #4d5bebed;
          position: absolute;
          bottom: -6%;
        }
      }
    }
  }

  &_list {
    width: 64%;
    height: auto;
    margin: auto;

    ul {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      align-content: start;
      flex-wrap: wrap;
      min-height: 30vw;
      margin-top: 3vw;

      li {
        width: 14%;
        height: 4vw;
        margin-left: 2.3%;
        margin-top: 20px;
        background: #fff;

        &:hover {
          transform: scale(1.1);
          box-shadow: 1px 2px 8px 3px #cfcccc29;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

@media (max-width: 1920px) {
  .Partners {
    width: 100%;
    height: auto;
    margin: auto;

    &_list {
      ul {
        li {
          height: 4vw;
        }
      }
    }
  }
}

@media (max-width: 550px) {
  .Partners {
    width: 100%;
    height: auto;
    margin: auto;

    &_title {
      font-size: 5vw;
      font-weight: bold;
    }

    &_bar {
      width: 95%;
      height: 20vw;

      ul {
        justify-content: space-around;
        border-bottom: none;

        li {
          font-size: 3.6vw;
        }
      }
    }

    &_list {
      width: 94%;
      margin-bottom: 12vw;
      ul {
        li {
          width: 30%;
          height: 15vw;
        }
      }
    }
  }
}
</style>
